import { useContext, useMemo } from 'react';
import { get } from 'lodash';

import AuthorizationContext from '../contexts/AuthorizationContext';
import EmployerContext from '../contexts/EmployerContext';
import { titles, favicons } from '../constants/Titles';

const useSetTitle = () => {
    const {
        isTalenyaUser, isTalentExpertUser, isEmployerRepAdmin, user, employerRep,
    } = useContext(AuthorizationContext);
    const { employer } = useContext(EmployerContext);

    const isPaycorEmployerRep = useMemo(
        () => user && employerRep
            && !(get(user, 'permissions.isEmployerRepAdmin'))
            && (get(user, 'origUserPrefs.resellerEmployerId')
                || get(user, 'origUserPrefs.isAssociatedEmployer')),
        [user, employerRep],
    );

    const isPaycorEmployerRepAdmin = useMemo(
        () => user && employerRep
            && (get(user, 'permissions.isEmployerRepAdmin'))
            && (get(user, 'origUserPrefs.resellerEmployerId')
                || get(user, 'origUserPrefs.isAssociatedEmployer')),
        [user, employerRep],
    );

    return (paths = []) => {
        const isCalibrationPage = paths?.length && paths.includes('employer') && paths.includes('wizard');
        const isNoAccessPage = paths?.length && paths.includes('no-access-page');
        const isNoAccessCalibration = !isTalenyaUser && !isTalentExpertUser && !isEmployerRepAdmin && employer?.settings?.isOnlyFastRatingAllowed;
        const shouldChange = isPaycorEmployerRepAdmin || (isPaycorEmployerRep && (isNoAccessPage || isNoAccessCalibration || isCalibrationPage));
        document.title = shouldChange ? titles.PAYCOR : titles.TALENYA;
        const link = document.querySelector("link[rel~='icon']");
        if (link) {
            link.href = shouldChange ? favicons.PAYCOR : favicons.TALENYA;
        }
    };
};
export default useSetTitle;
